import { useGetUser } from '@web/api/users/use-get-user';
import { setAccessToken } from '@web/redux/authentication-slice';
import { useAppDispatch } from '@web/redux/store';
import { useEffect } from 'react';
import { BuildType, setBuildType } from '../../../redux/Development';
import { prepareCompaniesQuery } from '../helpers/prepareCompaniesQuery';
import { ValidUrlDefinition } from '../helpers/validateNextUrl';

type AuthenticationData =
  | {
      isLoading: true;
      isError: false;
    }
  | {
      isLoading: false;
      isError: true;
    }
  | {
      isLoading: false;
      isError: false;
      url: string;
    };

const useStateNormalize = (token: string, data: unknown, isError: boolean) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!data || isError) {
      return;
    }

    dispatch(setBuildType(BuildType.embedded));
    dispatch(setAccessToken(token));
  }, [data, isError, token]);
};

export const useNextUrl = (target: ValidUrlDefinition, token: string): AuthenticationData => {
  const { data, isPending, isError } = useGetUser({
    enabled: !!token,
  });
  useStateNormalize(token, data, isError);

  if (isPending) {
    return {
      isLoading: isPending,
      isError: false,
    };
  }
  if (isError) {
    return { isLoading: isPending, isError };
  }

  const targetEntity = prepareCompaniesQuery(data.companies)[target.entity];
  const targetParams = new URLSearchParams(targetEntity ? { entity: targetEntity } : {});
  target.queryParams.forEach(([key, value]) => targetParams.set(key, value.toString()));

  const url = `/${target.url}?${targetParams.toString()}`;

  return {
    isError,
    isLoading: isPending,
    url,
  };
};
